import { useMantineTheme } from "@mantine/core";
import { type ThemeFlags } from "src/interfaces/customTheme";

const NO_FLAGS: ThemeFlags = {};

/**
 * Reads the client-supplied feature flags that ThemeWrapper puts on the Mantine
 * theme. Prefer this over `useTheme()` when you only need the flags - `useTheme`
 * re-runs the custom theme dynamic import effect for every consumer.
 *
 * @returns {ThemeFlags} The active flags, or an empty object when no custom theme is loaded.
 */
export const useThemeFlags = (): ThemeFlags => {
  const { other } = useMantineTheme();
  return (other?.flags as ThemeFlags | undefined) ?? NO_FLAGS;
};

/**
 * True while a client's custom theme file is still being fetched, i.e. the
 * flags are not trustworthy yet.
 */
export const useIsThemeLoading = (): boolean => {
  const { other } = useMantineTheme();
  return Boolean(other?.isLoadingCustomTheme);
};
